import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "editor-color",
  "use": "editor-color-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 22\" id=\"editor-color\"><path fill=\"currentColor\" d=\"M0 17.043h20v4H0zm3.49-3h2.42l1.27-3.58h5.65l1.26 3.58h2.42l-5.26-14h-2.5zm4.42-5.61 2.03-5.79h.12l2.03 5.79z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol